var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.25,
    height: 91.25,
    viewBox: "0 0 91.25 91.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560",
    transform: "translate(-1187 -2579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M40.3,40.3V29.426L29.426,40.3Z",
    transform: "translate(1237.953 2629.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M35.9,50.834,50.834,35.9V24.265L24.265,50.834Z",
    transform: "translate(1227.416 2619.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M30.718,61.328,61.351,30.7V19.125l-42.237,42.2Z",
    transform: "translate(1216.899 2608.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M25.565,71.845l46.3-46.267v-11.6l-57.9,57.871Z",
    transform: "translate(1206.385 2598.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M20.394,82.359,82.359,20.425V8.824L8.824,82.359Z",
    transform: "translate(1195.891 2587.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M3.674,92.876H15.305l77.569-77.6V3.673Z",
    transform: "translate(1185.376 2577.374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M80.663,3,3,80.663v11.6L92.264,3Z",
    transform: "translate(1184 2576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M65,3,3,65V76.6L76.6,3Z",
    transform: "translate(1184 2576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M49.331,3,3,49.331v11.6L60.932,3Z",
    transform: "translate(1184 2576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M33.666,3,3,33.633V45.267L45.3,3Z",
    transform: "translate(1184 2576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M18,3,3,18.032V29.6L29.6,3Z",
    transform: "translate(1184 2576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M3,3V13.971L13.929,3Z",
    transform: "translate(1184 2576)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterials);
export default __webpack_public_path__ + "static/media/materials.06146bfd99428d53dffe6484961a4892.svg";
export { ForwardRef as ReactComponent };